import { Text } from "@meditect/medibase-components";

export const CSVExportError = (): React.ReactElement => {
  return <Text>Impossible d'exporter le CSV</Text>;
};
